import { EServiceId } from '../../types/reducers/publishTerms';

type TWordCase = 'nominative' | 'prepositional';

type TWordCases = {
  [key in TWordCase]: { [key in EServiceId]: string };
};

interface IPluralServiceNameParams {
  wordCase?: TWordCase;
}

const WORD_CASES: TWordCases = {
  // Именительный падеж (что?)
  nominative: {
    [EServiceId.top]: 'Топ',
    [EServiceId.premium]: 'Премиум',
    [EServiceId.paid]: 'Стандарт',
    [EServiceId.free]: 'Стандарт',
  },
  // Предложный падеж (в чём?)
  prepositional: {
    [EServiceId.top]: 'Топе',
    [EServiceId.premium]: 'Премиуме',
    [EServiceId.paid]: 'Стандарте',
    [EServiceId.free]: 'Стандарте',
  },
};

/**
 *
 * @description Склоняет имя услуги в указанном падеже
 */
export function getServiceName(serviceId: EServiceId, params?: IPluralServiceNameParams): string {
  const { wordCase = 'nominative' } = params || {};

  return WORD_CASES[wordCase][serviceId];
}
